type ImpactStyle = "light" | "medium" | "heavy" | "rigid" | "soft";
type NotificationType = "error" | "success" | "warning";

const vibrate = (pattern: number | number[]) => {
  if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
    navigator.vibrate(pattern);
  }
};

export const hapticImpact = (style: ImpactStyle = "light"): void => {
  const ms = style === "heavy" || style === "rigid" ? 20 : 10;
  vibrate(ms);
};

export const hapticNotification = (type: NotificationType): void => {
  if (type === "error") vibrate([20, 40, 20]);
  else if (type === "warning") vibrate([15, 30, 15]);
  else vibrate(15);
};
